import React, { useState } from "react";
import { useVenue } from "../context/VenueContext";
import { loginWithSpotify } from "../services/spotifyService";

// Host-only: choose the playlist that plays whenever nobody has requested a song
export default function FallbackPlaylistPanel() {
  const { fallback, setFallbackPlaylist, clearFallbackPlaylist } = useVenue();
  const [input, setInput] = useState("");
  const [editing, setEditing] = useState(false);

  const loading = fallback?.status === "loading";
  const ready = fallback?.status === "ready";
  const showForm = !ready || editing;

  const save = async () => {
    if (!input.trim() || loading) return;
    await setFallbackPlaylist(input);
    setInput("");
    setEditing(false);
  };

  const box = {
    margin: "18px auto 0", maxWidth: 440, padding: "16px 18px", textAlign: "left",
    background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 20,
  };
  const small = { fontSize: 12, color: "rgba(255,255,255,0.4)", lineHeight: 1.5 };
  const pill = {
    padding: "8px 16px", borderRadius: 100, border: "1px solid rgba(255,255,255,0.15)", background: "none",
    color: "rgba(255,255,255,0.7)", fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 600, cursor: "pointer",
  };

  return (
    <div style={box}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#ffffff", marginBottom: 4 }}>Venue playlist</div>
      <div style={{ ...small, marginBottom: 12 }}>
        Plays when nobody has requested a song. Requests always play first.
      </div>

      {ready && !editing && (
        <>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#ffffff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {fallback.name}
          </div>
          <div style={{ ...small, marginBottom: 12 }}>{fallback.count} songs, shuffled</div>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={pill} onClick={() => setEditing(true)}>Change</button>
            <button style={pill} onClick={clearFallbackPlaylist}>Remove</button>
          </div>
        </>
      )}

      {showForm && (
        <>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && save()}
            placeholder="Paste a Spotify playlist link"
            style={{
              width: "100%", padding: "12px 14px", borderRadius: 12, background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.1)", color: "#ffffff", fontFamily: "'DM Sans', sans-serif",
              fontSize: 14, outline: "none", marginBottom: 8,
            }}
          />
          {fallback?.status === "error" && (
            <div style={{ fontSize: 12, color: "#ff9b9b", lineHeight: 1.5, marginBottom: 8 }}>
              {fallback.error}
              {fallback.needsAccess && (
                <div style={{ marginTop: 8 }}>
                  <button style={pill} onClick={() => loginWithSpotify("venue", { playlists: true })}>
                    Allow playlist access
                  </button>
                </div>
              )}
            </div>
          )}
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={save}
              disabled={loading || !input.trim()}
              style={{
                padding: "10px 20px", borderRadius: 100, border: "none", background: "#1DB954", color: "#fff",
                fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 700,
                cursor: loading || !input.trim() ? "not-allowed" : "pointer", opacity: loading || !input.trim() ? 0.5 : 1,
              }}
            >
              {loading ? "Loading…" : "Save playlist"}
            </button>
            {editing && <button style={pill} onClick={() => setEditing(false)}>Cancel</button>}
          </div>
          <div style={{ ...small, marginTop: 10 }}>
            In Spotify: open the playlist, then Share → Copy link to playlist.
          </div>
        </>
      )}
    </div>
  );
}
